import * as React from 'react';
import { DefinedBgColorProvider } from '~theme/BgColorProvider';
import { SetBodyBgColor } from './components/SetBodyBgColor';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * highest BgColorProvider in the app
 * that will also set bgColor to the body element
 */
export var AppBgColorProvider = function AppBgColorProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsxs(DefinedBgColorProvider, {
    bgColor: "bgColors.primary",
    children: [/*#__PURE__*/_jsx(SetBodyBgColor, {}), children]
  });
};